// @flow
import { stylesheet } from 'typestyle';
import classnames from 'classnames';

import EveryPurchase from '@components/productDetail/pageFooter/EveryPurchase';
import GiaDiamond from '@components/productDetail/pageFooter/GiaDiamond';
import NeedHelp from '@components/productDetail/pageFooter/NeedHelp';

import css from '@styles/page_footer';

function Container({ children }) {
  return <div className={css.container}>{children}</div>;
}

function Left({ children }) {
  return <div className={css.left}>{children}</div>;
}

function Right({ children }) {
  return <div className={css.right}>{children}</div>;
}

export function List({ children, inline }) {
  return (
    <ul className={classnames(css.list, { [css.inlineList]: inline })}>
      {children}
    </ul>
  );
}

export function Item({
  children,
  icon,
  noUnderline,
  iconStyles = {},
  style = {}
}) {
  return (
    <li
      className={classnames(css.item, {
        [css.itemWithIcon]: !!icon,
        [css.underlinedItem]: !noUnderline
      })}
      style={style}
    >
      {icon ? <img src={icon} style={iconStyles} className={css.icon} /> : null}
      {children}
    </li>
  );
}

function PageFooter() {
  return (
    <Container>
      <Left>
        <EveryPurchase />
      </Left>
      <Right>
        <GiaDiamond />
        <NeedHelp />
      </Right>
    </Container>
  );
}

export default PageFooter;
